/** Tutorial metadata shared by marketplace pages. */
export const BUYER_VIDEO = {
  variant: 'buyer',
  youtubeId: 'klH5Y4clZvY',
  poster: '/static/videos/racketport-how-to-buy.webp',
  videoTitleId: 'LandingPage.videos.buyer.title',
};

export const SELLER_VIDEO = {
  variant: 'seller',
  youtubeId: '_W3uohGVeEw',
  poster: '/static/videos/racketport-how-to-sell.webp',
  videoTitleId: 'LandingPage.videos.seller.title',
};
